import { useGraphqlQuery } from "graphql-mock"
import { Card } from "materia"
import type { DeadlineStatus } from "../../../graphql"
import { DueAndOverdue } from "../DueAndOverdue"
import { query } from "./gql"

import s from "./FilterHeader.module.scss"

export const FilterHeaderConnected = ({
  description,
  title,
  deadlineStatus,
}: {
  description: string
  title: string
  deadlineStatus: DeadlineStatus | undefined
}) => {
  const { data, error, isPending } = useGraphqlQuery(query, {})

  if (isPending) return null
  if (error) return null

  const { dueCount, overdueCount } = data.deadlineProgressSummary

  return (
    <FilterHeader
      description={description}
      title={title}
      dueCount={dueCount}
      overdueCount={overdueCount}
      deadlineStatus={deadlineStatus}
    />
  )
}

export const FilterHeader = ({
  description,
  title,
  deadlineStatus,
  dueCount,
  overdueCount,
}: {
  description: string
  title: string
  dueCount: number
  overdueCount: number
  deadlineStatus: DeadlineStatus | undefined
}) => {
  return (
    <Card>
      <Card.Content>
        <div className={s.filterHeader}>
          <div className={s.filterHeader__title}>{title}</div>
          <div className={s.filterHeader__description}>{description}</div>

          <div className={s.filterHeader__filters}>
            <DueAndOverdue
              variant="due"
              isActive={deadlineStatus === "due"}
              count={dueCount}
            />
            <DueAndOverdue
              variant="overdue"
              isActive={deadlineStatus === "overdue"}
              count={overdueCount}
            />
          </div>
        </div>
      </Card.Content>
    </Card>
  )
}
